import { Box, Stack } from '@mui/material';
import { FieldMediaUpload, FieldTextRequired } from '../../../form';
import { SlideFormProps } from './types';
import SlidePreview from './SlidePreview';
import { iriToId } from '../../../util';

export default function FactSlideForm({
  slide,
  onUpdateField,
}: SlideFormProps) {
  return (
    <Stack direction="row" gap={3}>
      <Box sx={{ flex: 1 }}>
        <Stack gap={2}>
          <FieldTextRequired
            field={{
              name: 'markdown',
              label: 'Description',
              value: slide.templateData.markdown,
              handleValueChange: (value) => onUpdateField('markdown', value),
            }}
            multiline
            rows={4}
            helperText="max. 250 characters"
            slotProps={{
              htmlInput: {
                maxLength: 250,
              },
            }}
          />
          <Stack gap={1}>
            <FieldMediaUpload
              field={{
                name: 'background_image_id',
                label: 'Background Image (optional)',
                value: slide.templateData.background_image_id,
                handleValueChange: (value) =>
                  onUpdateField(
                    'background_image_id',
                    value ? iriToId(value) : null,
                  ),
              }}
              acceptedTypes={['IMAGE_TYPE']}
              existingImageId={slide.templateData.background_image_id}
              helperText="9:16 aspect ratio"
              aspectRatio="9/16"
              required
            />
          </Stack>
        </Stack>
      </Box>

      <SlidePreview
        title={slide.templateData.title}
        description={slide.templateData.markdown}
        backgroundImage={slide.templateData.background_image_id}
        type="fact"
      />
    </Stack>
  );
}
